import React from 'react'
import PropTypes from 'prop-types'
import * as fb from '../../Firebase/auth'
import Loader from '../Controls/Loader'
import FormUnverifiedEmail from '../UserForms/FormUnverifiedEmail'
import FormLoginModal from '../UserForms/FormLoginModal'
import FormError from '../UserForms/FormError'
import UserInfo from './UserInfo'
import UserInfos from './UserInfos'
import FormSetPersistence from '../UserForms/FormSetPersistence'
import './index.css'

const PAGES = {
  UNVERIFIED_EMAIL: 1,
  MAIN: 2,
  RELOGIN: 3,
  SET_PERSISTENCE: 4,
  ERROR: 5
}

const getInitPage = emailVerified => emailVerified ? PAGES.MAIN : PAGES.UNVERIFIED_EMAIL

class User extends React.Component {
  constructor (props) {
    super(props)
    const initPage = getInitPage(this.props.emailVerified)
    this.state = {
      activePage: initPage,
      busy: false,
      errorInfo: null,
      prevPage: initPage,
      reAuthSubject: null,
      newEmail: null,
      newPassword: null
    }
    this.go = this.go.bind(this)
    this.handleReload = this.handleReload.bind(this)
    this.handleSendEmail = this.handleSendEmail.bind(this)
    this.handleRename = this.handleRename.bind(this)
    this.handleUpdateEmail = this.handleUpdateEmail.bind(this)
    this.handleUpdatePassword = this.handleUpdatePassword.bind(this)
    this.handleReauthenticate = this.handleReauthenticate.bind(this)
    this.handlePersistence = this.handlePersistence.bind(this)
    this.handlePersistenceSet = this.handlePersistenceSet.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
    this.handleError = this.handleError.bind(this)
    this.handleErrorSubmit = this.handleErrorSubmit.bind(this)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.emailVerified !== this.props.emailVerified) {
      const initPage = getInitPage(nextProps.emailVerified)
      this.setState({
          activePage: initPage,
          prevPage: initPage
      })
    }
  }

  go (page) {
    this.setState({
      activePage: page,
      busy: false
    })
  }

  handleReload () {
    this.setState({
      busy: true,
      prevPage: PAGES.UNVERIFIED_EMAIL
    })
    fb.reload(verified => {
      this.setState({
        busy: false
      })
      if (verified) {
        this.props.onEmailVerified()
        this.props.onSuccessReload()
      } else {
        alert('E-mail ještě nebyl ověřen.')
      }
    }, this.handleError)
  }

  handleSendEmail () {
    this.setState({
      busy: true
    })
    fb.sendEmail(() => {
      this.setState({
        busy: false
      })
      alert('Ověřovací e-mail byl odeslán.')
    }, this.handleError)
  }

  handleRename () {
    const name = prompt('Nové jméno:', this.props.userName)
    if(!name) {
      return
    }
    this.setState({
      busy: true,
      prevPage: PAGES.MAIN
    })
    fb.updateUserName(name, () => {
      this.setState({
        busy: false
      })
      this.props.onUpdateName(name)
    }, this.handleError)
  }

  handleUpdateEmail (second) {
    let email
    if (!second) {
      email = prompt('Nový e-mail:', this.props.email)
      if(!email) {
        return
      }
      this.setState({
        busy: true,
        reAuthSubject: 'e-mailové adresy',
        newEmail: email,
        prevPage: PAGES.MAIN
      })
    } else {
      email = this.state.newEmail
    }
    fb.updateEmail(email, () => {
      this.setState({
        busy: false
      })
      this.props.onUpdateEmail(email)
      this.handleSendEmail()
    }, error => {
      if (error.code === 'auth/requires-recent-login') {
        this.go(PAGES.RELOGIN)
      } else {
        this.handleError(error)
      }
    })
  }

  handleUpdatePassword (second) {
    let password
    if (!second) {
      password = prompt('Nové heslo:')
      if(!password) {
        return
      }
      this.setState({
        busy: true,
        reAuthSubject: 'hesla',
        newPassword: password,
        prevPage: PAGES.MAIN
      })
    } else {
      password = this.state.newPassword
    }
    fb.updatePassword(password, () => {
      this.setState({
        busy: false
      })
      alert('Heslo bylo změněno.')
      this.go(this.state.prevPage)
    }, error => {
      if (error.code === 'auth/requires-recent-login') {
        this.go(PAGES.RELOGIN)
      } else {
        this.handleError(error)
      }
    })
  }

  handleReauthenticate (name, email, password) {
    let action
    if (this.state.reAuthSubject === 'hesla') {
      action = () => this.handleUpdatePassword(true)
    } else {
      action = () => this.handleUpdateEmail(true)
    }
    fb.reauthenticate(email, password, action, this.handleError)
  }

  handlePersistence () {
    this.go(PAGES.SET_PERSISTENCE)
  }

  handlePersistenceSet (persistence) {
    this.setState({
      busy: true,
      prevPage: PAGES.MAIN
    })
    fb.setPersistence(persistence, () => {
      alert(persistence ? 'Přihlášení bude zachováno.' : 'Přihlášení nebude zachováno')
      this.setState({
        busy: false
      })
      this.go(PAGES.MAIN)
    }, this.handleError)
  }

  handleLogout () {
    fb.logout(this.props.onLogout, this.handleError)
  }

  handleError (error) {
    this.setState({
      busy: false,
      errorInfo: error
    })
    this.go(PAGES.ERROR)
  }

  handleErrorSubmit () {
    this.setState({
      errorInfo: null
    })
    this.go(this.state.prevPage)
  }

  render () {
    if (this.state.busy) {
      return <Loader />
    }
    const p = PAGES
    let form
    switch (this.state.activePage) {
      case PAGES.UNVERIFIED_EMAIL:
        form = <React.Fragment>
          <FormUnverifiedEmail email={this.props.email} onReload={this.handleReload}
            onSendEmail={e => this.handleSendEmail()} />
          <UserInfo label='' value='' onClick={this.handleLogout} buttonText='Odhlásit' />
        </React.Fragment>
        break
      case p.MAIN:
        form = <UserInfos
          userName={this.props.userName}
          email={this.props.email}
          onRename={this.handleRename}
          onResetEmail={e => this.handleUpdateEmail()}
          onResetPassword={e => this.handleUpdatePassword()}
          persistence={this.props.persistence}
          onPersistenceSet={this.handlePersistence}
          account={this.props.account}
          onAccount={this.props.onAccount}
          onLogout={this.handleLogout} />
        break
      case p.RELOGIN:
        form = <FormLoginModal onSubmit={this.handleReauthenticate}
          onCancel={() => this.go(PAGES.MAIN)} subject={this.state.reAuthSubject} />
        break
      case p.SET_PERSISTENCE:
        form = <FormSetPersistence onYes={() => this.handlePersistenceSet(false)}
          onNo={() => this.handlePersistenceSet(true)} onCancel={() => this.go(PAGES.MAIN)} />
        break
      case p.ERROR:
        form = <FormError errorInfo={this.state.errorInfo} onSubmit={this.handleErrorSubmit} />
        break
      default:
        form = null
    }
    let title = null
    if (!this.state.errorInfo) {
      title = <h2 className='up-h2'>Přihlášený uživatel: <span className='c-1'>
          {this.props.userName}</span></h2>
    }
    return (
      <div className='up-con'>
        {title}
        {form}
      </div>
    )
  }
}

User.propTypes = {
  userName: PropTypes.string,
  emailVerified: PropTypes.bool,
  account: PropTypes.object,
  onSuccessReload: PropTypes.func,
  onUpdateName: PropTypes.func,
  onAccount: PropTypes.func,
  onLogout: PropTypes.func
}

export default User



// WEBPACK FOOTER //
// ./src/components/User/indexC.js